import React, { useEffect, useRef, useState } from "react";
import "./ApplicantForm.css";
import {
  GetApplicantForm,
  GetFormTemplateById,
  GetViewFormDetail,
  UpdateApplicantForm,
} from "../apis/FormAPI";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import ImportScript from "../utils/customHooks/ImportScript";
import { useAlert } from "react-alert";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";

const ApplicantForm = (props) => {
  const {user} = useSelector((state) => state.auth);
  var alert = useAlert();
  var applicationid = 0;
  var custId = 0;
  var token = "";
  var id = "";
  var isDownload = false;
  var user_ip = "";
  
  if (props.token === undefined) {
    token = getParameterByName("token");
    id = getParameterByName("id");
    applicationid = getParameterByName("applicationid");
    custId = getParameterByName("custId");
    isDownload = false;
  } else {
    token = props.token;
    id = props.templateid;
    isDownload = true;
  }

  if (!token.includes("download")) {
    ImportScript("signaturePad.js");
    ImportScript("customscripts.js");
  }
  ImportScript("https://api.ipify.org?format=jsonp&callback=getIP");

  const initialHtmlState = {
    content: { "form-html": "<p>Loading...</p>" },
  };

  const [htmlData, setHtmlData] = useState(initialHtmlState);
  const [formData, setFormData] = useState([]);
  const [requireSignature, setRequireSignature] = useState(false);
  const [hideAction, setHideAction] = useState(true);
  const navigate = useNavigate();
  const [showAlreadyFormSubmit, setShowAlreadyFormSubmit] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const handleAlreadyFormSubmit = (e) => {
    setShowAlreadyFormSubmit(false);
  };
  const containerRef = useRef(null);
  const [previewLoaded, setPreviewLoaded] = useState(false);
  const [viewLoaded, setViewLoaded] = useState(false);

  const [showSaveLoader, setShowSaveLoader] = useState(false);
  const [showSbmtLoader, setShowSbmtLoader] = useState(false);

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  useEffect(() => {
    async function GetForm() {
      if (token === "preview" || token === "preview_download") {
        if (id != "0") {
          var result = await GetFormTemplateById(id);
          var html = result.data.templateHtml;
          setHtmlData({ content: { "form-html": html } });
          setHideAction(true);
          setPreviewLoaded(true);
        }
      } else if (token === "view" || token === "view_download") {
        console.log(user.customerid);
        result = await GetViewFormDetail(
          applicationid,
          id,
          user.customerid == "0" ? custId : user.customerid,
          token
        );
        html = result.data.item1.templateHtml;
        setHtmlData({ content: { "form-html": html } });
        setFormData(JSON.parse(result.data.item2));
        setHideAction(true);
        setViewLoaded(true);
      } else {
        if (token != null) {
          result = await GetApplicantForm(token);
          if (result.data.item3 === 1) {
            html = result.data.item1.templateHtml;
            setHtmlData({ content: { "form-html": html } });
            setFormData(JSON.parse(result.data.item2));
            setRequireSignature(result.data.item4);
            setHideAction(false);
          } else {
            setHtmlData("");
            setHideAction(true);
            setShowAlreadyFormSubmit(true);
          }
        }
      }
    }
    GetForm();
  }, [id]);

  useEffect(() => {
    formData.map((e, i) => {
      var elemId = Object.keys(e)[0];
      var elemValue = Object.values(e)[0];
      var elemClass = e.class;
      var elemById = document.getElementById(elemId);
      var elemByValue = document.getElementById(elemValue);
      if (
        elemId != "" &&
        elemId != null &&
        (elemById != null || elemByValue != null)
      ) {
        if (e.type === "textarea") {
          elemById.textContent = elemValue;
        } else if (e.type !== "radio" && e.type !== "checkbox") {
          if (elemId.includes("signature")) {
            var idPart = elemId.split("_");
            var imgId = `signatureImg_${idPart[1]}`;
            document.getElementById(imgId).src = elemValue;
            document.getElementById(imgId).style.display = "inline-block";
            document.getElementById(elemId).style.display = "none";
            document.getElementById(imgId).style.width = "auto";
            document.getElementById(imgId).style.maxWidth = "100%";
          } else elemById.value = elemValue;
        } else {
          if (e.type === "radio") {
            elemByValue.checked = true;
          } else if (e.type === "checkbox") {
            elemById.checked = elemValue;
            elemById.className = elemClass;
          }
        }
      } else if (elemClass.includes("admr")) {
        var divId = elemClass.substring(elemClass.indexOf("admr"));
        if (e.dataId == "0") addDynamicRow(divId, elemId, elemValue);
        else {
          var ls_row = document.getElementById(divId).lastChild;
          var inputs = ls_row.getElementsByTagName("input");
          inputs[e.dataId].id = elemId;
          inputs[e.dataId].value = elemValue;
          inputs[e.dataId].classList.add(divId);
          inputs[e.dataId].setAttribute("data-id", e.dataId);
        }
      }
    });
    if (formData.length > 0) {
      autoEnableRadioElements();
      addEventListener();
    }
    if (props.token != undefined) props.viewLoaded(viewLoaded);
  }, [formData.length]);

  useEffect(() => {
    if (htmlData != initialHtmlState && formData.length === 0) {
      autoEnableRadioElements();
      addEventListener();
      if (props.type != undefined) props.previewLoaded(previewLoaded);
    }
  }, [htmlData]);

  function autoEnableRadioElements() {
    const container = containerRef.current;
    const inputs = container.getElementsByTagName("input");
    for (var i in inputs) {
      if (inputs[i].type == "radio") {
        var id = inputs[i].id;
        var inputs2 = document.getElementsByClassName(id);
        if (inputs2.length > 0) {
          for (var j in inputs2) {
            var id2 = inputs2[j].id;
            if (id2 !== undefined) {
              if (inputs[i].checked)
                document.getElementById(id2).disabled = false;
              else {
                document.getElementById(id2).value = "";
                document.getElementById(id2).disabled = true;
              }
            }
          }
        }
      }
    }
  }

  function addEventListener() {
    var container = containerRef.current;
    var elements = container.getElementsByClassName("calculate");
    for (var i = 0; i < elements.length; i++) {
      //console.log(elements[i]);
      elements[i].addEventListener("blur", sumFunction, false);
    }
  }

  var sumFunction = function () {
    var attribute = this.getAttribute("data-id");
    var allfields = document.querySelectorAll('[data-id="' + attribute + '"]');
    var sum = 0;
    for (var i = 0; i < allfields.length; i++) {
      var vl = allfields[i].value;
      if (vl == "") vl = 0;
      sum += parseFloat(vl);
    }
    document.querySelector('[data-id="total_' + attribute + '"]').value = sum;
    calculateNetWorth();
    calculateTotalWorth();
  };

  var calculateNetWorth = function () {
    let subcals = document.querySelectorAll(".subcal");
    var ntwrth = 0;
    var asstId = "";
    var liblId = "";
    var asst = 0;
    var libl = 0;
    subcals.forEach((elem) => {
      let attr = elem.getAttribute("data-id");

      if (attr.includes("asset") || attr.includes("actif")) {
        asst = parseInt(elem.value == "" ? 0 : elem.value);
        asstId = attr;
      }
      if (attr.includes("liable") || attr.includes("passif")) {
        libl = parseInt(elem.value == "" ? 0 : elem.value);
        liblId = attr;
      }

      ntwrth = asst - libl;
    });
    //.log(ntwrth);
    document.querySelector(`[data-id="${asstId}_${liblId}"`).value = ntwrth;
  };

  var calculateTotalWorth = function () {
    let grnd = document.querySelectorAll(".grandcal");
    let asst = 0;
    let asstId = "";
    let attr = "";
    grnd.forEach((elem) => {
      attr = elem.getAttribute("data-id");
      asst += parseInt(elem.value == "" ? 0 : elem.value);
      if (asstId == "") asstId = attr;
      else asstId += "_" + attr;
      //console.log(asstId);
    });
    if (grnd.length > 0)
      document.querySelector(`[data-id="${asstId}"]`).value = asst;
  };

  function GetFormData() {
    //const container = containerRef.current;
    const inputElem = document.getElementsByTagName("input");
    const txtAreaElem = document.getElementsByTagName("textarea");
    user_ip = document.getElementById("userIP").value;
    var formData = [];
    for (var indx = 0; indx < inputElem.length; indx++) {
      var elemId = inputElem[indx].id;
      var elemName = inputElem[indx].name;
      var elemValue = inputElem[indx].value;
      var elemType = inputElem[indx].type;
      var elemClasses = inputElem[indx].classList.value;
      var dataId = inputElem[indx].getAttribute("data-id");
      //console.log(elemType);
      if (elemId != "") {
        if (
          elemType !== "radio" &&
          elemType !== "checkbox" &&
          elemType != "hidden"
        ) {
          if (elemId.includes("signature")) {
            var idPart = elemId.split("_");
            var imgSrc = document.getElementById(
              `signatureImg_${idPart[1]}`
            ).src;
            if(!imgSrc.includes("http")){
              elemValue = imgSrc;
            }
          }
          var inputObj = {
            [elemId]: elemValue,
            type: elemType,
            class: elemClasses,
            dataId: dataId,
          };
          formData.push(inputObj);
        } else {
          //console.log(inputElem[indx]);
          if (elemType === "radio") {
            if (inputElem[indx].checked) {
              inputObj = {
                [elemName]: elemId,
                type: elemType,
                class: elemClasses,
                dataId: dataId,
              };

              formData.push(inputObj);
            }
          } else if (elemType === "checkbox") {
            inputObj = {
              [elemId]: inputElem[indx].checked,
              type: elemType,
              class: elemClasses,
              dataId: dataId,
            };

            formData.push(inputObj);
          }
        }
      }
    }
    for (var indx = 0; indx < txtAreaElem.length; indx++) {
      elemId = txtAreaElem[indx].id;
      elemValue =
        txtAreaElem[indx].textContent == ""
          ? txtAreaElem[indx].value
          : txtAreaElem[indx].textContent;
      elemType = txtAreaElem[indx].type;
      elemClasses = inputElem[indx].classList.value;
      dataId = inputElem[indx].getAttribute("data-id");
      inputObj = {
        [elemId]: elemValue,
        type: elemType,
        class: elemClasses,
        dataId: dataId,
      };
      formData.push(inputObj);
    }
    return formData;
  }

  async function saveForm() {
    let btnSave = document.getElementById("btnSave");
    btnSave.disabled = true;
    var data = {
      id: 0,
      totalRows: 0,
      formTemplateId: 0,
      customerId: 0,
      userId: 0,
      orderId: null,
      applicantName: "",
      applicantAddress: "",
      applicantEmail: "",
      requireSignature: false,
      applicantNotes: "",
      formData: JSON.stringify(GetFormData()),
      formStatusId: 1,
      formStatusName: "",
      token: token,
      userIP: user_ip,
    };
    //console.log(data);
    setShowSaveLoader(true);
    var result = await UpdateApplicantForm(data);
    if (result.status === 200) {
      alert.success("Form saved.", { onClose: () => setShowSaveLoader(false) });
      btnSave.disabled = false;
    } else {
      alert.error("Unable to save form", {
        onClose: () => setShowSaveLoader(false),
      });
      btnSave.disabled = false;
    }
  }

  function validateForm() {
    if (requireSignature) {
      let signImgs = document.querySelectorAll("img[id*='signature']");
      let allsigned = true;
      let signCount = 0;
      signImgs.forEach((simg) => {
        let src = simg.src;
        if (
          !src.includes("http") &&
          src !== "" &&
          src !== undefined &&
          src !== null
        )
          signCount = 1;
      });
      if (signCount == 0) allsigned = false;
      return allsigned;
    }
    return true;
  }

  async function submitForm() {
    let btnSubmit = document.getElementById("btnSubmit");
    btnSubmit.disabled = true;
    if (document.getElementById("AgreeTermsCheck").checked && validateForm()) {
      confirmAlert({
        title: "Submit Form",
        message:
          "Are you sure want to submit the form? Once submitted it cannot be changed later. Please verify all the filled details once.",
        buttons: [
          {
            label: "Yes",
            className: "yesbtn",
            onClick: async () => {
              var data = {
                id: 0,
                totalRows: 0,
                formTemplateId: 0,
                customerId: 0,
                userId: 0,
                orderId: null,
                applicantName: "",
                applicantAddress: "",
                applicantEmail: "",
                requireSignature: false,
                applicantNotes: "",
                formData: JSON.stringify(GetFormData()),
                formStatusId: 2,
                formStatusName: "",
                token: token,
                userIP: user_ip,
              };
              setShowSbmtLoader(true);
              var result = await UpdateApplicantForm(data);
              if (result.status === 200) {
                alert.success("Form submitted", {
                  onClose: () => navigate("/ThankYou"),
                });
              } else {
                alert.error("Error! Unable to submit form", {
                  onClose: () => setShowSbmtLoader(false),
                });
                btnSubmit.disabled = false;
              }
            },
          },
          {
            label: "No",
            className: "nobtn",
            onClick: () => {
              btnSubmit.disabled = false;
            },
          },
        ],
      });
    } else {
      if (requireSignature) {
        btnSubmit.disabled = false;
        alert.error(
          "Please sign the applicant wherever required and accept terms and conditions before submitting the form."
        );
      } else {
        btnSubmit.disabled = false;
        alert.error(
          "Please accept terms and conditions before submitting the form."
        );
      }
    }
  }

  function addDynamicRow(cls, id, val) {
    //console.log(cls);
    var add_rm_html = `<div class="col-lg-2 col-md-2 col-sm-12"><div class="form-section-col mb-3 row text-center"><a href="javascript:void(0)" onclick="addRow('${cls}')">+</a><a href="javascript:void(0)" onclick="removeRow(this,'${cls}')">x</a></div></div>`;
    var rm_html = `<div class="col-lg-2 col-md-2 col-sm-12"><div class="form-section-col mb-3 row text-center"><a href="javascript:void(0)" onclick="removeRow(this,'${cls}')">x</a></div></div>`;
    //console.log(document.getElementById(cls));
    if (document.getElementById(cls) != null) {
      var ln = document.getElementById(cls).children.length;
      var ls_row = document.getElementById(cls).lastChild;
      if (ls_row.lastChild.tagName == undefined)
        ls_row.removeChild(ls_row.lastChild);
      ls_row.removeChild(ls_row.lastChild);
      var nw_row = ls_row.cloneNode(true);
      nw_row.innerHTML += add_rm_html;
      if (ln > 1) ls_row.innerHTML += rm_html;
      nw_row.getElementsByTagName("input")[0].id = id;
      nw_row.getElementsByTagName("input")[0].classList.add(cls);
      nw_row.getElementsByTagName("input")[0].setAttribute("data-id", 0);
      nw_row.getElementsByTagName("input")[0].value = val;
      document.getElementById(cls).appendChild(nw_row);
    }
  }

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div
              className={
                isDownload ? "abstract-request watermark" : "abstract-request"
              }
              ref={containerRef}
              dangerouslySetInnerHTML={{
                __html: htmlData?.content?.["form-html"],
              }}
            ></div>
            <div className={isDownload ? "pdf-footer d-flex" : "pdf-footer"}>
              <div className="pdf-downloaded-by">
               {isDownload ? `Downloaded by: ${user.useremail}` : ''}
              </div>
              <div className="pdf-downloaded-date">
                Date: {new Date().toLocaleString() + ""}
              </div>
            </div>
            {hideAction ? (
              ""
            ) : (
              <div className="agree-terms">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="AgreeTermsCheck"
                  />
                  <label className="form-check-label" htmlFor="AgreeTermsCheck">
                    By signing the document, I agree to be bound by all of the{" "}
                    <a
                      href="javascript:void(0);"
                      onClick={() => setShowDisclaimer(true)}
                    >
                      terms & condition
                    </a>{" "}
                    and acknowledges the authentication of information provided.
                  </label>
                </div>
              </div>
            )}
          </div>
          {hideAction ? (
            ""
          ) : (
            <div className="text-center form-action-btn">
              <button
                id="btnSave"
                type="button"
                className="btn form-save-btn"
                onClick={saveForm}
              >
                Save
                <Loader visible={showSaveLoader} ibutton={true} />
              </button>
              <button
                id="btnSubmit"
                type="button"
                className="btn form-submit-btn"
                onClick={submitForm}
              >
                Submit
                <Loader visible={showSbmtLoader} ibutton={true} />
              </button>
            </div>
          )}
        </div>
        <input type="hidden" id="userIP" />
      </div>

      <Modal
        className="logOTPmodal"
        centered
        backdrop="static"
        show={showAlreadyFormSubmit}
        onHide={handleAlreadyFormSubmit}
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Body>
          <div className="otp-lock-icon">
            <i className="fa-solid fa-check"></i>
          </div>
          <p className="otp-msg">Form already submitted.</p>
        </Modal.Body>
      </Modal>
      <Modal
        className="modal-xl"
        centered
        backdrop="static"
        show={showDisclaimer}
        onHide={() => setShowDisclaimer(false)}
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <div>
            <h3>Disclaimer</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Declaration.</strong> I/We hereby declare to the best of my
            knowledge the information in this Application is complete, true and
            accurate.Consent to Collection of Personal Information. I/We consent
            to the collection of such personal information as INSERT COMPANY
            NAME and its agent, Quality Credit Services Limited, consider
            necessary to verify the information in my/our application as true
            and complete at any time in connection with my/our application for
            credit and any renewal or extension thereof. I/We are agreeable to
            the Landlord in obtaining subsequent creditinformation throughout
            the duration of the lease. Personal Information will be collected,
            used, retained and disclosed in accordance with our Privacy Notice{" "}
            <a
              href="https://www.qualitycreditreporting.com/website-privacy-policy"
              target="_blank"
              rel="noopener"
            >
              (https://www.qualitycreditreporting.com/website-privacy-policy)
            </a>
            .{" "}
          </p>
          <p>
            <strong>Profiling.</strong> I/We consent to the use of personal
            information to create a profile of me/us for the purposes of
            assessing credit risk.
          </p>
          <p>
            <strong>Consent to Release of Personal Information.</strong> I/We
            consent to the disclosure of this Application to any source of
            information necessary to validate the information in this
            Application and to any credit reporting agency. I/We understand that
            this information will be subject to the source’s privacy policy.
            This executed Application (or any true copy thereof) shall be good
            and sufficient authority to the said sources, including my/our
            financial institution(s) to release information (including account
            balances) about me/we to INSERT COMPANY NAME. and Quality Credit
            Services Limited and I direct such sources to do so..
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => setShowDisclaimer(false)}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <div id="signatureModal" className="signature-modal">
        <div className="signature-modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Signature Pad <small>hold left button to sign with cursor</small>
            </h5>

            <span className="close">&times;</span>
          </div>
          <input type="hidden" id="signatureId" />
          <input type="hidden" id="signatureData" />
          <div className="row">
            <div className="wrapper">
              <canvas
                id="signature-pad"
                className="signature-pad"
                width="400"
                height="200"
              ></canvas>
            </div>
          </div>
          <div className="row sigbtn">
            <div className="col-lg-4 col-md-4 col-sm-12">
              <button type="button" className="btn btn-primary" id="clear">
                Clear
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <button type="button" className="btn btn-primary" id="undo">
                Undo
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <button type="button" className="btn btn-primary" id="save">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplicantForm;
